<div class="welcome-container darkWhiteBG50 dFlex fCol alignItemsCenter">
  <div class="welcome dFlex justifyContentCenter">
    <div class="welcome-header dFlex fCol primaryBG">
      @if (brandingService.currentBranding?.logo_url) {
      <a routerLink="/" class="partner-logo marTop25 marLeft20 marRight20 dFlex">
        <img
          [src]="brandingService.currentBranding.logo_url"
          alt="{{ brandingService.currentBranding.company_name }}"
          class="partner-logo-img"
        />
      </a>
      } @else {
      <a routerLink="/" class="logo white marTop25 marLeft20 marRight20 dFlex"></a>

      <hr class="whiteBG mar20 marLeft40 marRight40 opat25" />
      }
      <div class="whiteT marLeft20 marRight20">
        <div>
          <h1 class="w300 marBot20">
            Welcome to {{ brandingService.currentBranding?.company_name || 'SimpleCitizen' }}
          </h1>
        </div>
      </div>
    </div>

    <div class="mainBody noPad whiteBG dFlex">
      <div class="width100 pad30">
        @switch (focus) { @default {
        <section class="pageTitle tAlignLeft">
          <h3 class="darkGrey w300 tAlignCenter">Sign In</h3>
          <hr class="darkWhiteBG marTop20 marBot20 opat25" />
          <form
            #emailPasswordForm
            [formGroup]="loginForm"
            [action]="nextPath ? '/auth/complete/email/?next=' + nextPath : '/auth/complete/email/'"
            method="post"
            (ngSubmit)="passwordRequired ? submitEmailPasswordForm(emailPasswordForm) : checkEmail($event)"
          >
            <!-- We have to have these hidden/disabled fields to prevent password managers from
                autofilling the email address and resetting the form.
                -->
            <input
              type="email"
              [name]="enablePasswordManagerBypass ? 'email' : 'hidden-disabled-email'"
              hidden
              disabled
            />
            <input
              type="password"
              [name]="enablePasswordManagerBypass ? 'password' : 'hidden-disabled-password'"
              hidden
              disabled
            />
            <label class="marTop25">
              <input
                #emailField
                type="email"
                id="email"
                [name]="enablePasswordManagerBypass ? 'disabled-email-field' : 'email'"
                class="field auth-field lightGreyBG50"
                (focus)="emailFieldFocused = true"
                (blur)="emailFieldFocused = false"
                [class.is-empty]="!loginForm.get('email').value"
                [autocomplete]="passwordRequired ? 'off' : 'on'"
                formControlName="email"
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'envelope']" class="marRight5"></fa-icon> Email
                  <em class="required">*</em>
                </span>
              </span>
            </label>
            @if (passwordRequired) {
            <label class="marTop25">
              <input
                #passwordField
                type="password"
                id="password"
                [name]="enablePasswordManagerBypass ? 'disabled-password-field' : 'password'"
                class="field auth-field lightGreyBG50"
                [class.is-empty]="!loginForm.get('password').value"
                formControlName="password"
                [required]="passwordRequired"
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password
                  <em class="required">*</em>
                </span>
              </span>
              <app-password-toggle [field]="passwordField"></app-password-toggle>
            </label>
            }
            <div class="marTop25 marBot10">
              <input
                type="checkbox"
                class="checkmark"
                id="rememberUsername"
                name="rememberUsername"
                formControlName="rememberUsername"
              />
              <label for="rememberUsername" class="noPad dFlex justifyContentFlexStart alignItemsCenter">
                <div class="absolute marLeft40 dFlex fCol justifyContentFlexStart alignItemsFlexStart">
                  <p class="noMar">Remember my username</p>
                  <p class="fs-875 medGreyT noMar">Do not select this option on a public device</p>
                </div>
              </label>
            </div>
            @if (errorMsg) {
            <p class="redT">{{ errorMsg }}</p>
            }
            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                id="loginSubmit"
                class="button primary radius noMar marTop20 primaryBorder left width100"
                type="submit"
              >
                <fa-icon [icon]="['far', 'sign-in-alt']"></fa-icon>
                Login
              </button>
            </section>
            @if (passwordRequired) {
            <hr class="darkWhiteBG marTop20 marBot20 opat25" />
            <div class="tAlignCenter">
              <a
                [routerLink]="['/forgot-password']"
                [queryParams]="{
                  email: loginForm.get('email').value,
                  next: this.nextPath,
                  theme: brandingService.currentBranding?.theme
                }"
                class="primaryT w400 marTop20 button right"
              >
                Forgot your password?
              </a>
            </div>
            } @if (!brandingService.isB2b) {
            <hr class="darkWhiteBG marTop20 marBot20 opat25" />
            <div class="tAlignCenter">
              <p class="medGreyT noMar">
                Don't have an account?
                <a [href]="signUpUrl" class="primaryT w400" target="_blank" rel="noopener noreferrer"> Sign Up </a>
              </p>
            </div>
            }
          </form>
        </section>
        } @case ('forgotpassword') {
        <section class="pageTitle tAlignLeft">
          <h3 class="darkGrey w300 tAlignLeft">Forgot Password?</h3>
          <p class="darkGrey w300 tAlignLeft">
            Enter your {{ brandingService.currentBranding?.company_name || 'SimpleCitizen' }} account email address and
            we’ll send you instructions to reset your password.
          </p>
          <hr class="darkWhiteBG marTop20 marBot20 opat25" />
          <form #forgotPasswordForm="ngForm" (ngSubmit)="forgotPassword()">
            <label class="marTop25 oneColumn">
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'envelope']" class="marRight5"></fa-icon> Email
                  <em class="required">*</em>
                </span>
              </span>
              <input
                #forgotPasswordEmailInput="ngModel"
                type="email"
                id="forgotPasswordEmail"
                name="forgotPasswordEmail"
                class="field auth-field lightGreyBG50"
                [class.is-empty]="!forgotPasswordEmail"
                [(ngModel)]="forgotPasswordEmail"
                required
                [pattern]="emailRegex"
              />
            </label>
            @if ( forgotPasswordEmailInput.invalid && (forgotPasswordEmailInput.dirty ||
            forgotPasswordEmailInput.touched) ) {
            <div class="redT marTop5 marBot5">
              @if (forgotPasswordEmailInput.errors?.['required']) {
              <p>Email is required.</p>
              } @if (forgotPasswordEmailInput.errors?.['pattern']) {
              <p>Please enter a valid email address.</p>
              }
            </div>
            } @if (errorMsg) {
            <p class="redT">{{ errorMsg }}</p>
            }
            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius primaryBorder noMar marTop20 left width100"
                type="submit"
                [disabled]="forgotPasswordForm.invalid"
              >
                <fa-icon class="padRight10" [icon]="['far', 'lock']"></fa-icon>
                Send Reset Link
              </button>
            </section>
            <hr class="darkWhiteBG marTop20 marBot20 opat25" />
            <div class="marTop20 tAlignCenter">
              <a
                [routerLink]="['/welcome']"
                [queryParams]="{
                  email: emailText === forgotPasswordEmail ? emailText : null,
                  theme: brandingService.currentBranding?.theme
                }"
                class="primaryT w400 marTop20 button right"
              >
                Remember your password?
              </a>
              <a
                href="https://sc-learning-center.webflow.io/immigration-support/how-do-i-reset-my-password"
                class="primaryT w400 button right noPadTop"
                target="_blank"
                rel="noopener noreferrer"
              >
                Need Help?
              </a>
            </div>
          </form>
        </section>
        } @case ('newpassword') {
        <section class="pageTitle tAlignLeft">
          @switch (changePasswordMessageType) { @default {
          <h3 class="darkGrey w300 tAlignLeft">Set New Password.</h3>
          <p class="darkGrey w300 tAlignLeft">Create a new password.</p>
          } @case ('create') {
          <h3 class="darkGrey w300 tAlignLeft">Set Initial Password.</h3>
          <p class="darkGrey w300 tAlignLeft">
            @if (!useSso) {
            <span>Create an initial password for your account.</span>
            } @if (useSso) {
            <span>Login via SSO</span>
            }
          </p>
          } @case ('business-terms') {
          <h3 class="darkGrey w300 tAlignLeft">
            @if (!useSso) {
            <span>Set Initial Password</span>
            } @if (useSso) {
            <span>Welcome</span>
            }
          </h3>
          <p class="darkGrey w300 tAlignLeft">
            You have been invited to use SimpleCitizen through an immigration law firm. @if (!useSso) {
            <span class="dInline w300">Please create a password for your account.</span>
            }
          </p>
          } @case ('rafiki-terms') {
          <h3 class="darkGrey w300 tAlignLeft">
            @if (!useSso) {
            <span>Set Initial Password</span>
            } @if (useSso) {
            <span>Welcome</span>
            }
          </h3>
          <p class="darkGrey w300 tAlignLeft">
            You have been invited to use Rafiki. @if (!useSso) {
            <span class="dInline w300">Please create a password for your account.</span>
            }
          </p>
          } }
          <hr class="darkWhiteBG marTop20 marBot20 opat25" />
          @if (passwordRequirements) {
          <ul>
            @for (requirement of passwordRequirements; track requirement) {
            <li class="medGreyT">
              {{ requirement.helpText }}
            </li>
            }
          </ul>
          }
          <!-- <p class="medGreyT w400 marTop10 noMarBot">
              Contact your administrator if you have trouble logging in
            </p> -->
          <form #setNewPasswordForm="ngForm" (ngSubmit)="setNewPassword()">
            @if (!useSso) {
            <input
              type="email"
              name="username"
              autocomplete="username"
              [value]="emailText || ''"
              class="password-username"
              aria-label="Account email"
              aria-hidden="true"
              tabindex="-1"
              readonly
            />
            <label class="marTop25">
              <input
                #newPasswordField
                type="password"
                id="setNewPasswordText"
                name="setNewPasswordText"
                class="field auth-field lightGreyBG50"
                autocomplete="new-password"
                [(ngModel)]="setNewPasswordText"
                [class.is-empty]="!setNewPasswordText"
                [class.is-valid]="setNewPasswordText === setRetypeNewPasswordText && setNewPasswordText"
                [class.is-not-valid]="setNewPasswordText !== setRetypeNewPasswordText && startApplicationPasswordText"
                #newPasswordText="ngModel"
                required
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  @switch (changePasswordMessageType) { @default {
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> New Password
                  <em class="required">*</em>
                  } @case ('create') {
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password
                  <em class="required">*</em>
                  } @case ('business-terms') {
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password
                  <em class="required">*</em>
                  } @case ('rafiki-terms') {
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Password
                  <em class="required">*</em>
                  } }
                </span>
              </span>
              <app-password-toggle [field]="newPasswordField"></app-password-toggle>
            </label>
            } @if (!useSso) {
            <label class="marTop25">
              <input
                #retypePasswordField
                type="password"
                id="setRetypeNewPasswordText"
                name="setRetypeNewPasswordText"
                class="field auth-field lightGreyBG50"
                autocomplete="new-password"
                [attr.aria-describedby]="
                  setNewPasswordText && setRetypeNewPasswordText && setNewPasswordText !== setRetypeNewPasswordText
                    ? 'passwordMismatch'
                    : null
                "
                [attr.aria-invalid]="
                  !!(setNewPasswordText && setRetypeNewPasswordText && setNewPasswordText !== setRetypeNewPasswordText)
                "
                [class.is-empty]="!setRetypeNewPasswordText"
                [(ngModel)]="setRetypeNewPasswordText"
                [class.is-valid]="setNewPasswordText === setRetypeNewPasswordText && setRetypeNewPasswordText"
                [class.is-not-valid]="setNewPasswordText !== setRetypeNewPasswordText && setRetypeNewPasswordText"
                required
              />
              <span>
                <span class="dFlex justifyContentCenter">
                  <fa-icon [icon]="['far', 'key']" class="marRight5"></fa-icon> Verify <em class="required">*</em>
                </span>
              </span>
              <app-password-toggle [field]="retypePasswordField"></app-password-toggle>
            </label>
            } @if (changePasswordMessageType === 'business-terms' || changePasswordMessageType === 'rafiki-terms') {
            <div [class.marTop40]="!useSso" class="scRadioCheckbox">
              <p class="noMar">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  id="acceptTerms"
                  required
                  [(ngModel)]="acceptedTermsAndConditions"
                />
                <label class="smText dFlex alignItemsCenter" for="acceptTerms">
                  I Accept The Terms and Conditions
                </label>
              </p>
              <p class="medGreyT noMar">
                <span class="tinyText">
                  @if (changePasswordMessageType === 'business-terms') {
                  <a class="primaryT clickable" href="https://simplecitizen.com/terms-and-conditions/" target="_blank">
                    Terms and Conditions
                  </a>
                  } @if (changePasswordMessageType === 'rafiki-terms') {
                  <a
                    class="primaryT clickable"
                    href="https://simplecitizen.com/terms-of-service-rafiki/"
                    target="_blank"
                    >Terms and Conditions</a
                  >
                  }
                </span>
              </p>
            </div>
            } @if (errorMsg) {
            <p class="redT">{{ errorMsg }}</p>
            } @if ( setNewPasswordText && setRetypeNewPasswordText && setNewPasswordText !== setRetypeNewPasswordText )
            {
            <p id="passwordMismatch" class="redT" role="alert">Passwords must match.</p>
            } @if (!useSso) {
            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius dropShadow marTop20 left"
                [disabled]="
                  !(
                    setNewPasswordText &&
                    setRetypeNewPasswordText &&
                    setNewPasswordText === setRetypeNewPasswordText
                  ) ||
                  changePasswordMessageType === 'business-terms' ||
                  (changePasswordMessageType === 'rafiki-terms' && !acceptedTermsAndConditions) ||
                  loading
                "
                type="submit"
              >
                <fa-icon [icon]="['far', 'save']"></fa-icon>
                Save
              </button>
            </section>
            } @if (useSso) {
            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius dropShadow marTop20 left"
                [disabled]="!acceptedTermsAndConditions || loading"
                type="submit"
              >
                <fa-icon [icon]="['far', 'save']"></fa-icon>
                Login
              </button>
            </section>
            }
          </form>
        </section>
        } }
      </div>

      <form class="dNone" action="/auth/complete/email/" method="post" #loginAfterForm>
        <input type="hidden" name="email" [value]="loginAfterEmailText" />
        <input type="hidden" name="password" [value]="loginAfterPasswordText" />
      </form>
    </div>
  </div>
</div>
